<template>
    <div class="terms-root d-flex justify-content-center">
        <a
            class="mute mx-2"
            href="https://highered.global/terms-and-conditions/"
            target="_blank"
            rel="noopener noreferrer"
        >
            {{ $t('shared.termsAndConds.termsAndConditions') }}
        </a>
        <a
            class="mute mx-2"
            href="https://highered.global/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
        >
            {{ $t('shared.termsAndConds.privacyPolicy') }}
        </a>
        <a class="mute mx-2" :href="talentPanelUrl" target="_blank" rel="noopener noreferrer">
            {{ $t('shared.termsAndConds.talentPanel') }}
        </a>
    </div>
</template>

<script>
import UniversityService from '~/services/UniversityService';

const talentPanelShort = 'https://' + UniversityService.getCurrentDomain();

export default {
    name: 'TermsAndConds',
    data: function() {
        if (IS_PROD) {
            return {
                talentPanelUrl: talentPanelShort + '.talentpanel.io/',
            };
        }
        return {
            talentPanelUrl: talentPanelShort + '.talentpanel-dev.io/',
        };
    },
};
</script>

<style scoped>
.terms-root {
    font-size: 12px !important;
}
</style>
